import React from 'react';
import { m } from 'framer-motion';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { trustStats, trustBadges } from '../../data/trustStats';
export function TrustStats() {
  return <section className="border-y border-slate-200 bg-bg-secondary py-8 sm:py-10" data-id="element-252" data-mp="37qiugn60s8wn">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-253" data-mp="32sh9txsy41j2">
        <ScrollHintTable minWidth="640px" data-id="element-254" data-mp="32rz7cjfowr2p">
          <div className="grid grid-cols-4 divide-x divide-slate-200 bg-bg-primary" data-id="element-255" data-mp="2yqdomhgh5ikl">
            {trustStats.map((stat, i) => <m.div key={stat.label} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex flex-col items-center gap-2 px-3 py-6 text-center" data-id="element-256" data-mp="2tyvuac8yig8l" data-mpi={i}>
                <stat.icon size={22} className="text-flash" data-id="element-257" data-mp="2b11ixrkcvsn1" />
                <span className="font-heading text-xl font-bold text-ink sm:text-2xl" data-id="element-258" data-mp="2b1uparfekg4n">{stat.value}</span>
                <span className="text-xs text-muted sm:text-sm" data-id="element-259" data-mp="191yltroxcgi1">{stat.label}</span>
              </m.div>)}
          </div>
        </ScrollHintTable>

        <p className="mt-6 text-center font-heading text-sm font-bold uppercase tracking-wider text-success" data-id="element-260" data-mp="z5vf08j4ntor">
          ✓ El Estándar Profesional en el Patio
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-3" data-id="element-261" data-mp="1ru0xeompl6lf">
          {trustBadges.map((badge, i) => <m.div key={badge.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-bg-primary p-5 shadow-card" data-id="element-262" data-mp="1wslx8my1to9c" data-mpi={i}>
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-flash/10" data-id="element-263" data-mp="7gaevx8hq74q">
                <badge.icon size={20} className="text-flash" data-id="element-264" data-mp="2e26m8zzlpkl4" />
              </div>
              <div data-id="element-265" data-mp="2e40yzr0py6e4">
                <p className="font-heading text-sm font-bold text-ink" data-id="element-266" data-mp="293dapd3vk3nl">{badge.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-267" data-mp="24cdde6qufjkk">{badge.text}</p>
              </div>
            </m.div>)}
        </div>
      </div>
    </section>;
}